















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import quotationServices from '@/services/quotation-services';
import commonService from '@/services/common-services';
import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        Loading
    }
})
export default class CreateConsignment extends Vue {
    private isLoading: boolean = false;
    private isSubmitting: boolean = false;

    private currentUploadIdx: number = -1;
    private uploadingIdx: number = -1;

    private form: any = {
        service_type: 'ENTRUSTMENT',
        declaration_condition: 'ETL',
        warehouse_cn: 'Chính ngạch đường bộ (Có VAT)',
        warehouse_vn: '',
        legacy_china_store_id: null,
        legacy_receive_place_id: null,
        port_departure: '',
        port_arrival: '',
        note: '',
        items: [
            {
                mo_ta_chi_tiet: '',
                hinh_anh: '',
                don_gia_hoa_don_kh: 0,
                so_luong: 1,
                don_vi_tinh_vi: 'chiếc',
                link_hang_hoa: ''
            }
        ]
    };

    private portsList: any[] = [];
    private vnStoresList: any[] = [];

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerDisplayName(): string {
        if (!this.userInfo || !this.userInfo.userId) return '';
        const name = this.userInfo.userName || this.userInfo.fullName || '';
        return name ? `${this.userInfo.userId} - ${name}` : String(this.userInfo.userId);
    }

    private async mounted() {
        await Promise.all([
            this.loadPorts(),
            this.loadVnStores()
        ]);
        this.updateWarehouseDefault();
    }

    private async loadPorts() {
        try {
            const res: any = await quotationServices.getPorts();
            if (res && res.data && res.data.status === 200 && Array.isArray(res.data.data)) {
                this.portsList = res.data.data;
            }
        } catch (e) {
            console.error('Không thể tải danh sách cảng:', e);
        }
    }

    private async loadVnStores() {
        try {
            const res: any = await commonService.getWarehouse();
            const list = (res && res.data && (res.data.data || res.data)) || [];
            const all = Array.isArray(list) ? list : [];
            let filtered = all.filter((s: any) => (s.StoreType === 1 || s.store_type === 1) && (!s.IsHidden || s.IsHidden === 0));
            if (filtered.length === 0) {
                filtered = all.filter((s: any) => (!s.IsHidden || s.IsHidden === 0));
            }
            this.vnStoresList = filtered;
            await this.selectDefaultWarehouseVn();
        } catch (e) {
            console.error('Không thể tải kho VN:', e);
        }
    }

    private async selectDefaultWarehouseVn() {
        if (this.form.warehouse_vn && this.form.warehouse_vn !== 'Kho chính ngạch đường bộ có VAT') return;

        let receivePlaceId: any = null;
        if (this.userInfo && this.userInfo.userId > 0) {
            try {
                const res: any = await authService.customersInfo(this.userInfo.userId);
                if (res && res.status === 200 && res.data && res.data.data) {
                    receivePlaceId = res.data.data.ReceivePlaceID;
                    if (res.data.data.ChinaStoreID) {
                        this.form.legacy_china_store_id = res.data.data.ChinaStoreID;
                    }
                }
            } catch (err) {
                console.error('Không thể lấy thông tin khách hàng:', err);
            }
        }

        if (receivePlaceId && this.vnStoresList.length > 0) {
            const found = this.vnStoresList.find((s: any) => String(s.ID) === String(receivePlaceId));
            if (found && (found.Name || found.name)) {
                this.form.warehouse_vn = found.Name || found.name;
                this.form.legacy_receive_place_id = Number(found.ID);
                return;
            }
        }

        if (this.vnStoresList.length > 0) {
            const first = this.vnStoresList[0];
            this.form.warehouse_vn = first.Name || first.name;
            this.form.legacy_receive_place_id = Number(first.ID);
        } else {
            this.form.warehouse_vn = 'Kho Hà Nội';
        }
    }

    private onWarehouseVnChange() {
        this.errors.warehouse_vn = null;
        const found = this.vnStoresList.find((s: any) => (s.Name || s.name) === this.form.warehouse_vn);
        if (found) {
            this.form.legacy_receive_place_id = Number(found.ID);
        }
    }

    private get isPortCondition(): boolean {
        return ['LCL', 'FCL'].includes(this.form.declaration_condition);
    }

    private get warehouseHelpText(): string {
        if (['ECL', 'EFC'].includes(this.form.declaration_condition)) {
            return 'Điều kiện ' + this.form.declaration_condition + ' mặc định chuyển từ Kho chính ngạch đường biển có VAT.';
        }
        return 'Điều kiện ' + this.form.declaration_condition + ' mặc định chuyển từ Kho chính ngạch đường bộ có VAT.';
    }

    private updateWarehouseDefault() {
        const cond = this.form.declaration_condition;
        if (['ETL', 'EFT', 'LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5', 'FTL'].includes(cond)) {
            this.form.warehouse_cn = 'Chính ngạch đường bộ (Có VAT)';
            this.form.port_departure = '';
            this.form.port_arrival = '';
        } else if (['ECL', 'EFC'].includes(cond)) {
            this.form.warehouse_cn = 'Chính ngạch đường biển có VAT';
            this.form.port_departure = '';
            this.form.port_arrival = '';
        } else if (['LCL', 'FCL'].includes(cond)) {
            this.form.warehouse_cn = '';
            this.form.warehouse_vn = '';
            this.form.port_departure = '';
            this.form.port_arrival = '';
        }

        if (!['LCL', 'FCL'].includes(cond)) {
            if (!this.form.warehouse_vn || this.form.warehouse_vn === 'Kho chính ngạch đường bộ có VAT') {
                this.selectDefaultWarehouseVn();
            }
        }
    }

    private errors: any = {};

    private chooseImage(idx: number) {
        this.currentUploadIdx = idx;
        const fileInput = this.$refs.fileInput as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
            fileInput.click();
        }
    }

    private async handleFileChange(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0 || this.currentUploadIdx === -1) {
            return;
        }
        const file = files[0];
        if (!file.type.match(/^image\//)) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Vui lòng chọn định dạng file hình ảnh (jpg, png, webp, ...)!',
            });
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'File ảnh chỉ được tối đa 10MB!',
            });
            return;
        }

        const idx = this.currentUploadIdx;
        this.uploadingIdx = idx;

        try {
            const res: any = await quotationServices.uploadImage(file);
            if (res && res.data && res.data.status === 200 && res.data.data && res.data.data.url) {
                if (this.form.items[idx]) {
                    this.form.items[idx].hinh_anh = res.data.data.url;
                }
            } else {
                const errMsg = (res && res.data && (res.data.reason || res.data.detail || res.data.error)) || 'Tải ảnh lên R2 thất bại!';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Lỗi tải ảnh!',
                    text: errMsg,
                });
            }
        } catch (err) {
            const e: any = err;
            const errMsg = (e && e.response && e.response.data && (e.response.data.reason || e.response.data.detail)) || e.message || 'Lỗi tải ảnh lên R2!';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi tải ảnh!',
                text: errMsg,
            });
        } finally {
            this.uploadingIdx = -1;
            const fileInput = this.$refs.fileInput as HTMLInputElement;
            if (fileInput) {
                fileInput.value = '';
            }
        }
    }

    private removeImage(idx: number) {
        if (this.form.items[idx]) {
            this.form.items[idx].hinh_anh = '';
        }
    }

    private get availableConditions() {
        if (this.form.service_type === 'ENTRUSTMENT') {
            return [
                { label: 'ETL (Entrustment - Truck - Loading)', value: 'ETL' },
                { label: 'EFT (Entrustment - Full - Truck)', value: 'EFT' },
                { label: 'ECL (Entrustment - Container - Loading)', value: 'ECL' },
                { label: 'EFC (Entrustment - Full - Container)', value: 'EFC' },
            ];
        } else {
            return [
                { label: 'LTL1 - UNS TQ đứng tên xuất - Khách đứng tên nhập', value: 'LTL1' },
                { label: 'LTL2 - Xưởng TQ đứng tên xuất - Khách đứng tên nhập', value: 'LTL2' },
                { label: 'LTL3 - UNS TQ đứng tên xuất - Thuê giấy phép xuất khẩu - Khách đứng tên nhập', value: 'LTL3' },
                { label: 'LTL4 - UNS TQ đứng tên xuất - Thuê giấy phép xuất khẩu TQ - UNS đứng tên nhập khẩu', value: 'LTL4' },
                { label: 'LTL5 - Xưởng TQ đứng tên xuất - UNS đứng tên nhập khẩu', value: 'LTL5' },
                { label: 'FTL (Full - Truck - Loading)', value: 'FTL' },
                { label: 'LCL (Less - Container - Loading)', value: 'LCL' },
                { label: 'FCL (Full - Container - Loading)', value: 'FCL' },
            ];
        }
    }

    private get departurePortList() {
        const fromApi = this.portsList.filter((p: any) => p.region === 'CHINA');
        if (fromApi.length > 0) {
            return fromApi;
        }
        return [
            { name: 'Cảng Nam Sa (Nansha)', code: 'NSA' },
            { name: 'Cảng XIAMEN', code: 'XMN' },
            { name: 'Cảng Quảng Châu', code: 'CAN' },
            { name: 'Cảng Thâm Quyến', code: 'SZX' },
            { name: 'Cảng Thượng Hải', code: 'SHA' },
            { name: 'Cảng Ninh Ba', code: 'NGB' },
        ];
    }

    private get arrivalPortList() {
        const fromApi = this.portsList.filter((p: any) => p.region === 'VIETNAM');
        if (fromApi.length > 0) {
            return fromApi;
        }
        return [
            { name: 'Cảng Cát Lái', code: 'SGN' },
            { name: 'Cảng Hải Phòng', code: 'HPH' },
            { name: 'Cảng Đà Nẵng', code: 'DAN' },
            { name: 'Cảng Cái Mép', code: 'CME' },
        ];
    }

    private onServiceTypeChange() {
        if (this.form.service_type === 'ENTRUSTMENT') {
            this.form.declaration_condition = 'ETL';
        } else {
            this.form.declaration_condition = 'LTL1';
        }
        this.updateWarehouseDefault();
    }

    private onConditionChange() {
        this.updateWarehouseDefault();
    }

    private addItem() {
        this.form.items.push({
            mo_ta_chi_tiet: '',
            hinh_anh: '',
            don_gia_hoa_don_kh: 0,
            so_luong: 1,
            don_vi_tinh_vi: 'chiếc',
            link_hang_hoa: ''
        });
    }

    private removeItem(idx: number) {
        if (this.form.items.length > 1) {
            this.form.items.splice(idx, 1);
        }
    }

    private validate(): boolean {
        this.errors = {};
        let valid = true;

        if (!this.form.service_type) {
            this.errors.service_type = true;
            valid = false;
        }
        if (!this.form.declaration_condition) {
            this.errors.declaration_condition = true;
            valid = false;
        }
        if (!this.isPortCondition && !this.form.warehouse_vn) {
            this.errors.warehouse_vn = true;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi nhập liệu!',
                text: 'Vui lòng chọn kho nhận tại Việt Nam.'
            });
            valid = false;
        }

        let hasValidItem = false;
        for (const item of this.form.items) {
            if (item.mo_ta_chi_tiet && item.mo_ta_chi_tiet.trim()) {
                hasValidItem = true;
                break;
            }
        }

        if (!hasValidItem) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi nhập liệu!',
                text: 'Vui lòng nhập mô tả chi tiết cho ít nhất 1 mặt hàng.'
            });
            valid = false;
        }

        return valid;
    }

    private async submitForm() {
        if (this.uploadingIdx !== -1) {
            Vue.notify({
                group: 'foo',
                type: 'warning',
                title: 'Thông báo!',
                text: 'Hình ảnh đang được tải lên, vui lòng chờ trong giây lát...'
            });
            return;
        }

        if (!this.validate()) return;

        this.isSubmitting = true;
        this.isLoading = true;

        try {
            const validItems = this.form.items.filter(
                (it: any) => it.mo_ta_chi_tiet && it.mo_ta_chi_tiet.trim()
            );

            const payload = {
                customer_name: this.customerDisplayName,
                customer_legacy_id: this.userInfo ? this.userInfo.userId : null,
                service_type: this.form.service_type,
                declaration_condition: this.form.declaration_condition,
                warehouse_vn: this.form.warehouse_vn,
                warehouse_cn: this.form.warehouse_cn,
                receive_place_id: this.form.legacy_receive_place_id,
                china_store_id: this.form.legacy_china_store_id,
                legacy_receive_place_id: this.form.legacy_receive_place_id,
                legacy_china_store_id: this.form.legacy_china_store_id,
                port_departure: this.form.port_departure,
                port_arrival: this.form.port_arrival,
                note: this.form.note,
                customer_note: this.form.note,
                items: validItems
            };

            const res: any = await quotationServices.createConsignment(payload);

            if (res && res.data && res.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thành công!',
                    text: 'Đã tạo đơn ký gửi chính ngạch thành công!'
                });

                const createdId = (res.data && res.data.data) ? res.data.data.id : null;
                if (createdId) {
                    this.$router.push({
                        name: 'quotation-detail',
                        params: { id: createdId.toString() }
                    });
                } else {
                    this.$router.push({ name: 'quotation-index' });
                }
            } else {
                const errMsg = (res && res.data && (res.data.error || res.data.reason)) || 'Có lỗi xảy ra khi tạo đơn ký gửi.';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Lỗi tạo đơn!',
                    text: errMsg
                });
            }
        } catch (e) {
            const err = e as any;
            const errText = (err && err.message) ? err.message : 'Không thể kết nối máy chủ.';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi hệ thống!',
                text: errText
            });
        } finally {
            this.isSubmitting = false;
            this.isLoading = false;
        }
    }
}
